import { addHydrationListener } from "@cima/prism-utils/dist/hydration";

const autofocusCapableElementsSelector =
  "button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])";

function isFocusable(elem: HTMLElement) {
  return elem.matches(autofocusCapableElementsSelector);
}

export default (): void => {
  addHydrationListener(document.documentElement, () => {
    const autofocusElem = document.querySelector("[autofocus]") as HTMLElement;
    if (autofocusElem && !isFocusable(autofocusElem)) {
      autofocusElem.setAttribute("tabindex", "-1");
      autofocusElem.focus();
    }
  });
};
